export const termsTranslations  = {
  termsOfService: {
    title: "Terms of Service",
    description: "Please read these terms carefully before using our services. By using Quality Nexus, you agree to these terms.",
    lastUpdated: "Last updated:",
    sections: {
      acceptance: {
        title: "Acceptance of Terms",
        content: "By accessing and using Quality Nexus services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service."
      },
      services: {
        title: "Services Description",
        content: "Quality Nexus provides software testing services, community platform access, training programs, and consultation services. Our services are designed to help organizations improve their software quality and connect QA professionals.",
        categories: {
          title: "Service Categories",
          items: [
            "Comprehensive Testing Services",
            "Mentoring and Coaching Programs",
            "Crowd Testing Services",
            "Community Platform and Events"
          ]
        }
      },
      responsibilities: {
        title: "User Responsibilities",
        intro: "By using our services, you agree to:",
        items: [
          "Provide accurate and complete information when creating accounts",
          "Use our services only for lawful purposes and in accordance with these terms",
          "Respect intellectual property rights and confidentiality agreements",
          "Maintain the security of your account credentials"
        ]
      },
      prohibited: {
        title: "Prohibited Uses",
        intro: "You may not use our services to:",
        items: [
          "Violate any applicable laws or regulations",
          "Infringe on intellectual property rights",
          "Transmit malicious code or conduct security attacks",
          "Spam, harass, or abuse other users",
          "Reverse engineer or attempt to extract source code"
        ]
      },
      intellectualProperty: {
        title: "Intellectual Property",
        content: "The Quality Nexus platform, including its design, features, and content, is protected by copyright, trademark, and other intellectual property laws. You are granted a limited, non-exclusive license to use our services for their intended purpose."
      },
      liability: {
        title: "Limitation of Liability",
        content: "Quality Nexus shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of our services."
      },
      availability: {
        title: "Service Availability",
        content: "We strive to maintain high service availability but cannot guarantee uninterrupted access. We reserve the right to modify, suspend, or discontinue services with reasonable notice."
      },
      changes: {
        title: "Changes to Terms",
        content: "We reserve the right to modify these terms at any time. We will notify users of significant changes via email or platform notifications. Continued use of our services constitutes acceptance of updated terms."
      },
      contact: {
        title: "Contact Us",
        content: "If you have any questions about these Terms of Service, please contact us at:",
        details: {
          email: "Email: legal@qualitynexus.com",
          address: "Address: Quality Nexus Legal Team",
          businessAddress: "[Your Business Address]"
        }
      }
    }
  }
};